import * as types from './mutation-types.js'
const mutations = {
  [types.SET_NAVSHOW] (state, navShow) {
    state.navShow = navShow
  },
  [types.SET_IS_SHOW] (state, isShow) {
    state.isShow = isShow
  },
  [types.SET_IMG_URL] (state, imgUrl) {
    state.imgUrl = imgUrl
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js